import { render, staticRenderFns } from "./DropDownComponent.vue?vue&type=template&id=08ed2881"
import script from "./DropDownComponent.vue?vue&type=script&lang=js"
export * from "./DropDownComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports